import * as constants from 'data/CurrentUser/constants';

export function setCurrentUser(bearerToken, remember, expiry) {
  return {
    type: constants.SET_CURRENT_USER,
    bearerToken,
    expiry,
    remember,
  };
}

export function unsetCurrentUser() {
  return {
    type: constants.UNSET_CURRENT_USER,
  };
}

export function setCurrentMe(me) {
  return {
    type: constants.SET_CURRENT_ME,
    me,
  };
}

export function unsetCurrentMe() {
  return {
    type: constants.UNSET_CURRENT_ME,
  };
}
